module.exports = __webpack_public_path__ + "static/background-a33a623fe82f393038f503b5a25569fc.png";